import React, { Component } from 'react';
import axios from 'axios';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import queryString from 'query-string';
import AddedUPSList from './AddedUPSList';
import AddUPSForm from './AddUPSForm';
import SeButton from '../SeButton';
import { UPDATE_UPS_LIST, INITIAL_PATH } from '../../../config/consts';
import styles from './index.scss';

class SummaryPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tradeUps: [],
        };
    }

    componentDidMount() {
        this.getAddedUpsList();
    }

    getTotalVa = () => {
        const { tradeUps } = this.state;
        let totalIva = 0;
        totalIva = tradeUps.reduce(
            (accumulator, currentValue, currentIndex, array) => accumulator + parseInt(currentValue[3], 10),
            0,
        );
        return totalIva;
    };

    sendTradeUpsPersistRequest = () => {
        const { tradeUps } = this.state;
        const { tradeSite } = window;
        const locationArr = window.location.href.split('/');

        const countryCode = locationArr[5];
        const languageCode = locationArr[6];
        const URL = `${INITIAL_PATH}${countryCode}/${languageCode}${UPDATE_UPS_LIST}`;
        axios
            .post(
                URL,
                queryString.stringify({
                    totalIVA: this.getTotalVa(),
                    tradeUps: JSON.stringify(tradeUps),
                    tradeInVA: 0,
                    tradeSite,
                }),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                },
            )
            .then(result => {})
            .catch(err => {
                console.log(err);
            });
    };

    addNewUps = newUps => {
        const { tradeUps } = this.state;
        tradeUps.push(newUps);
        this.setState({
            tradeUps,
        });
        this.sendTradeUpsPersistRequest();
    };

    deleteUps = index => {
        const { tradeUps } = this.state;
        tradeUps.splice(index, 1);
        this.setState({
            tradeUps,
        });
        this.sendTradeUpsPersistRequest();
    };

    getAddedUpsList = () => {
        const upsListArr = window.tradeUps;
        if (upsListArr && upsListArr.length > 0) {
            this.setState({
                tradeUps: upsListArr,
            });
        }
    };

    render() {
        const { tradeUps } = this.state;
        const hideFormLabels = tradeUps && tradeUps.length > 0;
        const disabledButton = tradeUps.length === 0;
        const btnClass = classNames({
            [styles.btnWrapper]: true,
            'analytics-chooseNewUps': !disabledButton,
        });

        return (
            <div id="trade-it" className={styles.panelWrapper}>
                <h2 className={styles.header}>
                    <FormattedMessage id="tradeUps_enterTradeIn" />
                </h2>
                <div className={styles.upsList}>
                    {hideFormLabels ? <AddedUPSList deleteUps={this.deleteUps} tradeUps={tradeUps} /> : null}
                    <AddUPSForm hideFormLabels={hideFormLabels} addUps={this.addNewUps} />
                </div>

                <div className={btnClass}>
                    <SeButton
                        disabled={disabledButton}
                        external={true}
                        linkTo={`../search?Nty=1&Nf=sku.pwrRatedVA%7CBTWN+1+${this.getTotalVa() * 4}&Nr=sku.type:ups`}
                    >
                        <FormattedMessage id={'tradeUps_chooseNewUps'} />
                    </SeButton>
                </div>
            </div>
        );
    }
}
SummaryPanel.propTypes = {};

export default SummaryPanel;
